import { getDate } from '@/services/timeService';
import type { CustomEventEntry } from '@/services/useCustomEventsService';
import {
  formatFieldValueForDisplay,
  resolveEntryDefinition,
  useCustomEventsService,
} from '@/services/useCustomEventsService';

import type { IEventsList } from '../EventsList';

// A date-only effective time becomes *local* midnight on purpose: useTimeline
// groups by formatTime(date) in the viewer's timezone, so only a local-midnight
// instant lands on the recorded calendar day for every viewer offset.
const toTimelineDate = (entry: CustomEventEntry): string =>
  entry.isDateOnly ? getDate(entry.effectiveTime).toISOString() : entry.effectiveTime;

export default function useCustomEvent(patientUuid: string): IEventsList[] {
  const { patientSeries, definitions } = useCustomEventsService({ patientUuid });

  return (patientSeries ?? []).flatMap((series) =>
    series.entries.map((entry) => {
      const definition = resolveEntryDefinition(entry, definitions);
      const description = definition
        ? definition.fields
            .map((field) => ({
              name: field.label,
              description: formatFieldValueForDisplay(field, entry.values[field.name]),
            }))
            .filter((section) => section.description !== '')
        : [];

      return {
        name: series.name,
        date: toTimelineDate(entry),
        description,
        id: entry.id,
        isToHideEditIcon: true,
      };
    }),
  );
}
